module.exports = __webpack_public_path__ + "static/media/transfer.2c5f041a.svg";